import { render, staticRenderFns } from "./Featuresr.vue?vue&type=template&id=645f9137&"
import script from "./Featuresr.vue?vue&type=script&lang=js&"
export * from "./Featuresr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports